<template>
  <section class="hero singapore25">
      <div class="hero__content container">
        <div class="hero__content--info">
          <h1 class="hero__title">
            DNA House at TOKEN2049, Singapore
          </h1>
          <h2 class="hero__date">
            Oct 1st - 2nd, 2025
          </h2>
          <a href="http://lu.ma/dnafund" target="_blank">
            <button class="hero__btn">
              Register Now
            </button>
          </a>
          <div class="venue-logo">
            <a href="https://maps.app.goo.gl/Dk7xZXvKMdKj2mtj8" target="_blank">
              <img src="@/assets/singapore/mandala-white.png" class="logo" alt="Mandala's Logo">
            </a>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>

  export default {
    name: 'Hero',
    data () {
      return {
      }
    },
  }
  </script>
  
  <style lang="scss" scoped>
  @import "@/styles/components/hero.scss";

  .hero.singapore25 {
    padding: 100px 0 20px;
    min-height: 500px;
    background-image: linear-gradient(to bottom, rgb(0 0 0 / 90%) 0%, rgb(0 0 0 /65%)), url('~@/assets/general/singapore.webp');
  }
  </style>